import { GQLMapOrdersResponse, mapOrders } from 'graphql/geospatial/queries';
import { UseQueryOptions, useQuery } from 'react-query';

type Params = {
  agencyId?: string;
  status: string;
  geometryId: string;
  queryConfig?: UseQueryOptions<GQLMapOrdersResponse, Error, GQLMapOrdersResponse, any>;
};

export const useMapOrders = ({ agencyId, status, geometryId, queryConfig }: Params) =>
  useQuery(
    ['map-orders', { agencyId, status, geometryId }],
    () => mapOrders({ agencyId, status, geometryId }),
    {
      ...queryConfig,
      refetchOnWindowFocus: false,
      enabled: !!geometryId && queryConfig?.enabled !== false,
    }
  );
